import { FlexColumnSmallSpaced } from '@fox/layout';
import { DotLottieReact, DotLottieReactProps } from '@lottiefiles/dotlottie-react';
import { motion } from 'framer-motion';
import React, { useState } from 'react';
import { Typography } from '../typography';
// CREATE NEW PATHS FOR ANIMATIONS HERE:
const MOON = {
	fill: '#FF9D43',
	paths: {
		default:
			'M 121.17 33.416 C 117.97 26.206 113.3 19.746 107.46 14.466 C 101.62 9.186 94.74 5.196 87.26 2.756 C 79.79 0.316 71.89 -0.514 64.07 0.306 C 56.25 1.136 48.7 3.596 41.89 7.546 C 35.08 11.496 29.18 16.836 24.56 23.216 C 19.94 29.606 16.71 36.896 15.07 44.616 C 13.49 52.066 13.45 59.756 14.91 67.216 L 14.9 67.216 C 14.95 67.496 15.01 67.776 15.07 68.046 C 50.5 69.5 58 73.224 71 79 C 71 79 103.02 100.796 103.13 101.746 C 103.52 101.456 103.91 101.166 104.29 100.856 L 104.29 100.826 C 110.86 95.726 116.23 89.226 119.99 81.776 C 123.97 73.886 126.04 65.166 126.04 56.316 C 126.04 48.426 124.38 40.616 121.18 33.406 L 121.17 33.416 Z M 47.44 94.856 C 46.2 88.496 41.63 84.756 34.34 82.926 L 33.1 82.616 C 28.24 81.426 23.37 80.346 18.54 78.886 C 23.92 91.236 33.52 101.246 45.6 107.116 C 47.3 104.296 48.07 101.006 47.79 97.726 C 47.73 96.766 47.61 95.806 47.43 94.856 L 47.44 94.856 Z',
		shrink: 'M 118.399 35.508 C 115.375 28.71 110.963 22.619 105.445 17.64 C 99.928 12.662 93.427 8.9 86.36 6.599 C 79.302 4.298 71.838 3.516 64.45 4.289 C 57.061 5.071 49.928 7.391 43.494 11.115 C 37.06 14.84 31.485 19.875 27.12 25.891 C 22.755 31.916 19.703 38.79 18.154 46.069 C 16.661 53.093 16.623 60.344 18.003 67.379 L 17.993 67.379 C 18.041 67.642 18.097 67.906 18.154 68.161 C 51.629 69.532 58.715 73.043 70.997 78.489 C 70.997 78.489 101.25 99.041 101.354 99.937 C 101.723 99.663 102.091 99.39 102.45 99.097 L 102.45 99.069 C 108.658 94.261 113.731 88.132 117.284 81.107 C 121.044 73.668 123 65.445 123 57.101 C 123 49.661 121.432 42.297 118.408 35.499 L 118.399 35.508 Z M 48.737 93.44 C 47.566 87.443 43.248 83.917 36.36 82.192 L 35.189 81.899 C 30.597 80.777 25.996 79.759 21.432 78.382 C 26.515 90.027 35.586 99.465 46.999 105 C 48.605 102.341 49.333 99.239 49.068 96.146 C 49.011 95.241 48.898 94.336 48.728 93.44 L 48.737 93.44 Z'
	}
};

const MAIN = {
	fill: '#2F68D1',
	paths: {
		default:
			'M103.12 101.746C103.01 100.796 102.93 99.8562 102.79 98.8862C98.66 70.2162 85.7 46.3362 63.77 27.0962C62.13 25.7362 60.36 24.5562 58.48 23.5762C58.48 23.5762 58.48 31.539 58.48 36.6412C58.48 41.7434 58.48 49.7062 58.48 49.7062C49.66 51.1962 42.79 54.9262 36.92 60.7962C34.93 62.7862 31.97 64.2662 29.2 65.0062C28.06 65.3062 26.92 65.5662 25.77 65.8362C22.25 66.6662 18.68 67.3562 15.06 68.0562C13.25 68.4062 11.43 68.7662 9.59 69.1462C10.21 74.3162 13.36 77.2562 17.32 78.5262C17.73 78.6562 18.12 78.7662 18.51 78.8862C23.34 80.3662 28.2 81.4462 33.07 82.6162L34.31 82.9262C41.6 84.7562 46.17 88.4962 47.41 94.8562C47.59 95.8062 47.71 96.7562 47.77 97.7262C48.04 101.006 47.27 104.286 45.57 107.106C44.23 109.246 42.39 111.016 40.2 112.256C36.74 114.266 33 115.746 29.1 116.646C25.31 117.476 2.91 127.466 0 128.766C5.25 134.696 11.39 139.756 18.2 143.776C18.49 143.946 18.77 144.106 19.07 144.266C23.89 146.886 31.75 149.976 39.3 152.196C43.47 153.166 47.72 153.766 52 154.006C52.59 153.516 53.15 152.996 53.69 152.446C53.69 152.446 71.69 138.206 66.41 112.546C66.03 110.726 65.57 108.926 65.01 107.156C65.01 107.156 64.79 106.506 64.4 105.436C63.16 102.086 60.1 94.6062 56.12 90.2462C56.12 90.2462 53.16 86.0962 46.97 84.0262C40.78 81.9562 40.64 82.2462 40.64 82.2462L31.47 79.9562L18.32 76.6362C18.32 76.6362 16.47 75.7362 18.37 75.1962L38.64 77.3662C38.64 77.3662 58.79 78.9862 62.39 79.3762C65.99 79.7662 66.93 79.9662 66.93 79.9662C66.93 79.9662 68.02 80.1562 66.74 80.3762C65.57 80.6562 64.42 81.0162 63.3 81.4762C63.3 81.4762 59.77 82.6662 62.89 84.7962C62.89 84.7962 64.13 86.0862 67.96 87.6362C71.8 89.1862 72.43 89.5762 72.43 89.5762C72.43 89.5762 83.31 93.3962 88.69 99.2462C90.45 101.146 92 103.236 93.32 105.466C93.68 106.076 93.96 106.626 94.22 107.126C94.67 107.996 95.05 108.906 95.35 109.836C95.35 109.836 98.4 118.746 97.46 128.376C97.46 128.376 97.22 132.556 95.61 134.696C95.61 134.696 95.8 128.446 92.31 127.306C92.31 127.306 92.72 139.136 88.31 146.476C88.18 146.686 88.05 146.896 87.9 147.086C89.01 146.566 90.11 146.016 91.2 145.426C91.68 145.146 92.16 144.876 92.63 144.596C94.45 143.486 95.25 142.526 96.97 141.276C96.93 140.886 98.02 139.246 98.52 137.656C103.07 126.656 104.58 114.686 103.12 101.736V101.746Z',
		earTip: 'M103.12 101.746C103.01 100.796 102.93 99.8562 102.79 98.8862C98.66 70.2162 85.7 46.3362 63.77 27.0962C62.13 25.7362 60.36 24.5562 58.48 23.5762C58.48 23.5762 62.0748 31.581 62 37C61.9289 42.1485 58.48 49.7062 58.48 49.7062C49.66 51.1962 42.79 54.9262 36.92 60.7962C34.93 62.7862 31.97 64.2662 29.2 65.0062C28.06 65.3062 26.92 65.5662 25.77 65.8362C22.25 66.6662 18.68 67.3562 15.06 68.0562C13.25 68.4062 11.43 68.7662 9.59 69.1462C10.21 74.3162 13.36 77.2562 17.32 78.5262C17.73 78.6562 18.12 78.7662 18.51 78.8862C23.34 80.3662 28.2 81.4462 33.07 82.6162L34.31 82.9262C41.6 84.7562 46.17 88.4962 47.41 94.8562C47.59 95.8062 47.71 96.7562 47.77 97.7262C48.04 101.006 47.27 104.286 45.57 107.106C44.23 109.246 42.39 111.016 40.2 112.256C36.74 114.266 33 115.746 29.1 116.646C25.31 117.476 2.91 127.466 0 128.766C5.25 134.696 11.39 139.756 18.2 143.776C18.49 143.946 18.77 144.106 19.07 144.266C23.89 146.886 31.75 149.976 39.3 152.196C43.47 153.166 47.72 153.766 52 154.006C52.59 153.516 53.15 152.996 53.69 152.446C53.69 152.446 71.69 138.206 66.41 112.546C66.03 110.726 65.57 108.926 65.01 107.156C65.01 107.156 64.79 106.506 64.4 105.436C63.16 102.086 60.1 94.6062 56.12 90.2462C56.12 90.2462 53.16 86.0962 46.97 84.0262C40.78 81.9562 40.64 82.2462 40.64 82.2462L31.47 79.9562L18.32 76.6362C18.32 76.6362 16.47 75.7362 18.37 75.1962L38.64 77.3662C38.64 77.3662 58.79 78.9862 62.39 79.3762C65.99 79.7662 66.93 79.9662 66.93 79.9662C66.93 79.9662 68.02 80.1562 66.74 80.3762C65.57 80.6562 64.42 81.0162 63.3 81.4762C63.3 81.4762 59.77 82.6662 62.89 84.7962C62.89 84.7962 64.13 86.0862 67.96 87.6362C71.8 89.1862 72.43 89.5762 72.43 89.5762C72.43 89.5762 83.31 93.3962 88.69 99.2462C90.45 101.146 92 103.236 93.32 105.466C93.68 106.076 93.96 106.626 94.22 107.126C94.67 107.996 95.05 108.906 95.35 109.836C95.35 109.836 98.4 118.746 97.46 128.376C97.46 128.376 97.22 132.556 95.61 134.696C95.61 134.696 95.8 128.446 92.31 127.306C92.31 127.306 92.72 139.136 88.31 146.476C88.18 146.686 88.05 146.896 87.9 147.086C89.01 146.566 90.11 146.016 91.2 145.426C91.68 145.146 92.16 144.876 92.63 144.596C94.45 143.486 95.25 142.526 96.97 141.276C96.93 140.886 98.02 139.246 98.52 137.656C103.07 126.656 104.58 114.686 103.12 101.736V101.746Z',
		noseTwitch:
			'M103.12 101.746C103.01 100.796 102.93 99.8562 102.79 98.8862C98.66 70.2162 85.7 46.3362 63.77 27.0962C62.13 25.7362 60.36 24.5562 58.48 23.5762C58.48 23.5762 58.48 31.3978 58.48 36.5C58.48 41.6022 58.48 49.7062 58.48 49.7062C49.66 51.1962 42.79 54.9262 36.92 60.7962C34.93 62.7862 31.7 62.93 28.93 63.67C27.79 63.97 26.65 64.23 25.5 64.5C21.98 65.33 18.41 66.02 14.79 66.72C12.98 67.07 11.16 67.43 9.32 67.81C9.94 72.98 13.36 77.2562 17.32 78.5262C17.73 78.6562 18.12 78.7662 18.51 78.8862C23.34 80.3662 28.2 81.4462 33.07 82.6162L34.31 82.9262C41.6 84.7562 46.17 88.4962 47.41 94.8562C47.59 95.8062 47.71 96.7562 47.77 97.7262C48.04 101.006 47.27 104.286 45.57 107.106C44.23 109.246 42.39 111.016 40.2 112.256C36.74 114.266 33 115.746 29.1 116.646C25.31 117.476 2.91 127.466 0 128.766C5.25 134.696 11.39 139.756 18.2 143.776C18.49 143.946 18.77 144.106 19.07 144.266C23.89 146.886 31.75 149.976 39.3 152.196C43.47 153.166 47.72 153.766 52 154.006C52.59 153.516 53.15 152.996 53.69 152.446C53.69 152.446 71.69 138.206 66.41 112.546C66.03 110.726 65.57 108.926 65.01 107.156C65.01 107.156 64.79 106.506 64.4 105.436C63.16 102.086 60.1 94.6062 56.12 90.2462C56.12 90.2462 53.16 86.0962 46.97 84.0262C40.78 81.9562 40.64 82.2462 40.64 82.2462L31.47 79.9562L18.32 76.6362C18.32 76.6362 16.47 75.7362 18.37 75.1962L38.64 77.3662C38.64 77.3662 58.79 78.9862 62.39 79.3762C65.99 79.7662 66.93 79.9662 66.93 79.9662C66.93 79.9662 68.02 80.1562 66.74 80.3762C65.57 80.6562 64.42 81.0162 63.3 81.4762C63.3 81.4762 59.77 82.6662 62.89 84.7962C62.89 84.7962 64.13 86.0862 67.96 87.6362C71.8 89.1862 72.43 89.5762 72.43 89.5762C72.43 89.5762 83.31 93.3962 88.69 99.2462C90.45 101.146 92 103.236 93.32 105.466C93.68 106.076 93.96 106.626 94.22 107.126C94.67 107.996 95.05 108.906 95.35 109.836C95.35 109.836 98.4 118.746 97.46 128.376C97.46 128.376 97.22 132.556 95.61 134.696C95.61 134.696 95.8 128.446 92.31 127.306C92.31 127.306 92.72 139.136 88.31 146.476C88.18 146.686 88.05 146.896 87.9 147.086C89.01 146.566 90.11 146.016 91.2 145.426C91.68 145.146 92.16 144.876 92.63 144.596C94.45 143.486 95.25 142.526 96.97 141.276C96.93 140.886 98.02 139.246 98.52 137.656C103.07 126.656 104.58 114.686 103.12 101.736V101.746Z',
		earTipNoseTwitch:
			'M103.12 101.746C103.01 100.796 102.93 99.8562 102.79 98.8862C98.66 70.2162 85.7 46.3362 63.77 27.0962C62.13 25.7362 60.36 24.5562 58.48 23.5762C58.48 23.5762 60.5 31.3978 60.5 36.5C60.5 41.6022 58.48 49.7062 58.48 49.7062C49.66 51.1962 42.79 54.9262 36.92 60.7962C34.93 62.7862 31.7 62.93 28.93 63.67C27.79 63.97 26.65 64.23 25.5 64.5C21.98 65.33 18.41 66.02 14.79 66.72C12.98 67.07 11.16 67.43 9.32 67.81C9.94 72.98 13.36 77.2562 17.32 78.5262C17.73 78.6562 18.12 78.7662 18.51 78.8862C23.34 80.3662 28.2 81.4462 33.07 82.6162L34.31 82.9262C41.6 84.7562 46.17 88.4962 47.41 94.8562C47.59 95.8062 47.71 96.7562 47.77 97.7262C48.04 101.006 47.27 104.286 45.57 107.106C44.23 109.246 42.39 111.016 40.2 112.256C36.74 114.266 33 115.746 29.1 116.646C25.31 117.476 2.91 127.466 0 128.766C5.25 134.696 11.39 139.756 18.2 143.776C18.49 143.946 18.77 144.106 19.07 144.266C23.89 146.886 31.75 149.976 39.3 152.196C43.47 153.166 47.72 153.766 52 154.006C52.59 153.516 53.15 152.996 53.69 152.446C53.69 152.446 71.69 138.206 66.41 112.546C66.03 110.726 65.57 108.926 65.01 107.156C65.01 107.156 64.79 106.506 64.4 105.436C63.16 102.086 60.1 94.6062 56.12 90.2462C56.12 90.2462 53.16 86.0962 46.97 84.0262C40.78 81.9562 40.64 82.2462 40.64 82.2462L31.47 79.9562L18.32 76.6362C18.32 76.6362 16.47 75.7362 18.37 75.1962L38.64 77.3662C38.64 77.3662 58.79 78.9862 62.39 79.3762C65.99 79.7662 66.93 79.9662 66.93 79.9662C66.93 79.9662 68.02 80.1562 66.74 80.3762C65.57 80.6562 64.42 81.0162 63.3 81.4762C63.3 81.4762 59.77 82.6662 62.89 84.7962C62.89 84.7962 64.13 86.0862 67.96 87.6362C71.8 89.1862 72.43 89.5762 72.43 89.5762C72.43 89.5762 83.31 93.3962 88.69 99.2462C90.45 101.146 92 103.236 93.32 105.466C93.68 106.076 93.96 106.626 94.22 107.126C94.67 107.996 95.05 108.906 95.35 109.836C95.35 109.836 98.4 118.746 97.46 128.376C97.46 128.376 97.22 132.556 95.61 134.696C95.61 134.696 95.8 128.446 92.31 127.306C92.31 127.306 92.72 139.136 88.31 146.476C88.18 146.686 88.05 146.896 87.9 147.086C89.01 146.566 90.11 146.016 91.2 145.426C91.68 145.146 92.16 144.876 92.63 144.596C94.45 143.486 95.25 142.526 96.97 141.276C96.93 140.886 98.02 139.246 98.52 137.656C103.07 126.656 104.58 114.686 103.12 101.736V101.746Z'
	}
};

const EAR = {
	fill: '#2F68D1',
	paths: {
		default:
			'M36.3 33.6062L35.59 33.4462L35.82 34.1362C35.8316 34.2002 37.3616 38.6975 39 43.4513C40.179 46.8723 41.4142 50.4261 42.18 52.5562C45.86 50.2162 50.26 48.8062 54.9 47.7862C48.31 36.7962 36.41 33.6262 36.3 33.6062Z',
		tipped: 'M36.3 33.6062L35.59 33.4462L35.82 34.1362C35.8316 34.2002 40.2452 39.3667 41.5 43C42.7295 46.56 41.4142 50.4261 42.18 52.5562C45.86 50.2162 50.26 48.8062 54.9 47.7862C48.31 36.7962 36.41 33.6262 36.3 33.6062Z'
	}
};

// ADD NEW ANIMATED FOX COMPONENTS HERE:
// TODO: Add Examples to Storybook, reference these for now https://fox-logo-library.netlify.app/

export function LoadingFox({ loading, height, style }: { loading: boolean; height: string; style?: React.CSSProperties }) {
	return loading ? <LoadingDots /> : null;
}

type LoadingFoxWithCaptionProps = {
	/**
	 * The height setting for loading fox.
	 */
	height: string;
	/**
	 * Controls the visibility of loading fox.
	 */
	loading: boolean;
	/**
	 * The text that appears below loading fox.
	 */
	caption: string;
};

/**
 * A variant of the loading fox that includes a caption. The loading prop controls rendering, so no need to conditionally render in the component instance.
 */
export function LoadingFoxWithCaption({ height, loading, caption }: LoadingFoxWithCaptionProps) {
	return (
		<>
			{loading ? (
				<FlexColumnSmallSpaced style={{ alignItems: 'center', justifyContent: 'center' }}>
					<LoadingFox loading={loading} height={height} />
					<Typography variant="caption">{caption}</Typography>
				</FlexColumnSmallSpaced>
			) : (
				<></>
			)}
		</>
	);
}

export function HoverFox({ height }: { height: string }) {
	const moonMotion = {
		hover: {
			d: [MOON.paths.default, MOON.paths.shrink]
		}
	};

	const earMotion = {
		hover: {
			d: [EAR.paths.default, EAR.paths.tipped, EAR.paths.default, EAR.paths.tipped, EAR.paths.default]
		}
	};

	const mainMotion = {
		hover: {
			d: [MAIN.paths.default, MAIN.paths.earTip, MAIN.paths.default, MAIN.paths.earTipNoseTwitch, MAIN.paths.default]
		}
	};

	return (
		<div style={{ height }}>
			<motion.svg
				xmlns="http://www.w3.org/2000/svg"
				width="100%"
				height="100%"
				fill="none"
				viewBox="0 0 127 155"
				initial="rest"
				whileHover="hover"
				style={{ cursor: 'pointer' }}
			>
				<motion.path
					fill={MOON.fill}
					d={MOON.paths.default}
					variants={moonMotion}
					transition={{
						duration: 0.5,
						ease: 'easeInOut'
					}}
				></motion.path>
				<motion.path
					fill={EAR.fill}
					d={EAR.paths.default}
					transition={{
						repeat: Infinity,
						repeatType: 'loop',
						repeatDelay: 2
					}}
					variants={earMotion}
				></motion.path>
				<motion.path
					fill={MAIN.fill}
					d={MAIN.paths.default}
					transition={{
						repeat: Infinity,
						repeatType: 'loop',
						repeatDelay: 2
					}}
					variants={mainMotion}
				></motion.path>
			</motion.svg>
		</div>
	);
}

export function ClickFox({ height }: { height: string }) {
	const [motionState, setMotionState] = useState('rest');

	const moonMotion = {
		hover: {
			d: [MOON.paths.default, MOON.paths.shrink]
		}
	};

	const earMotion = {
		hover: {
			d: [EAR.paths.default, EAR.paths.tipped, EAR.paths.default, EAR.paths.tipped, EAR.paths.default]
		}
	};

	const mainMotion = {
		hover: {
			d: [MAIN.paths.default, MAIN.paths.earTipNoseTwitch, MAIN.paths.default, MAIN.paths.earTip, MAIN.paths.default]
		}
	};

	return (
		<div style={{ height }}>
			<motion.svg
				xmlns="http://www.w3.org/2000/svg"
				width="100%"
				height="100%"
				fill="none"
				viewBox="0 0 127 155"
				initial="rest"
				style={{ cursor: 'pointer' }}
				onClick={() => {
					setMotionState('hover');
					setTimeout(() => setMotionState('rest'), 500);
				}}
				animate={motionState}
			>
				<motion.path
					fill={MOON.fill}
					d={MOON.paths.default}
					variants={moonMotion}
					transition={{
						duration: 0.5,
						ease: 'easeInOut'
					}}
				></motion.path>
				<motion.path
					fill={EAR.fill}
					d={EAR.paths.default}
					transition={{
						repeat: Infinity,
						repeatType: 'loop',
						repeatDelay: 2
					}}
					variants={earMotion}
				></motion.path>
				<motion.path
					fill={MAIN.fill}
					d={MAIN.paths.default}
					transition={{
						repeat: Infinity,
						repeatType: 'loop',
						repeatDelay: 2
					}}
					variants={mainMotion}
				></motion.path>
			</motion.svg>
		</div>
	);
}

export function RisingFox({ height }: { height: string }) {
	return (
		<div style={{ height }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 127 155">
				<motion.path
					fill={MOON.fill}
					animate={{
						d: [MOON.paths.shrink, MOON.paths.default],
						opacity: [0, 1],
						translateX: [-10, 0],
						translateY: [10, 0]
					}}
					transition={{
						duration: 1.5,
						ease: 'easeInOut'
					}}
				></motion.path>
				<motion.path
					fill={EAR.fill}
					animate={{
						d: [EAR.paths.default, EAR.paths.tipped, EAR.paths.default, EAR.paths.tipped, EAR.paths.default],
						opacity: [0, 1],
						translateX: [-10, 0],
						translateY: [10, 0]
					}}
					transition={{
						duration: 1.5,
						ease: 'easeInOut',
						d: {
							delay: 1
						}
					}}
				></motion.path>
				<motion.path
					fill={MAIN.fill}
					animate={{
						d: [MAIN.paths.default, MAIN.paths.earTip, MAIN.paths.default, MAIN.paths.earTipNoseTwitch, MAIN.paths.default],
						opacity: [0, 1],
						translateX: [-10, 0],
						translateY: [10, 0]
					}}
					transition={{
						duration: 1.5,
						ease: 'easeInOut',
						d: {
							delay: 1
						}
					}}
				></motion.path>
			</svg>
		</div>
	);
}
const sizeMapping = {
	medium: '32px',
	large: '72px'
} as const;
/**
 * A UI team approved loading animation. Note if you want this displayed centered, use @see {@link LoadingDotsCenter}
 */
export function LoadingDots({ size = 'medium', ...props }: Omit<DotLottieReactProps, 'src' | 'width'> & { size?: keyof typeof sizeMapping }) {
	// Do not touch without consultation. These are specified by design team.

	return (
		<DotLottieReact
			height={sizeMapping[size]}
			src={'https://static.sfox.au/images/sf_preloader_v1-2-optimized.lottie'}
			loop
			autoplay
			{...props}
		/>
	);
}

export function LoadingDotsCenter() {
	return (
		<div style={{ display: 'grid', placeContent: 'center', height: '100%' }}>
			<LoadingDots size="large" />
		</div>
	);
}
